import React from 'react';

import { Box, Button, Heading, Text, ButtonPrimary } from '@primer/components'
import { Link } from "react-router-dom";
import { useProduct } from '../hooks/useProduct'


const pricings = [
  {
    title: "Individual",
    isPrimary: false,
    duration: 'forever',
    price: "Free",
    buttonLabel: "Add to GitHub",
    freeTrial: false,
    marketplaceUrl: "https://github.com/marketplace/django-doctor",
    features: {
      publicRepositories: "Unlimited",
      privateRepositories: "No",
      support: "No",
      ciTool: "Yes",
      browserTool: "Yes",
      autoFix: "Yes",
    }
  },
  {
    title: "Organization",
    isPrimary: true,
    duration: 'per month',
    price: "$49",
    isRibbon: true,
    buttonLabel: "Add to GitHub",
    freeTrial: true,
    marketplaceUrl: "https://github.com/marketplace/django-doctor/plan/MDIyOk1hcmtldHBsYWNlTGlzdGluZ1BsYW41Nzc1#pricing-and-setup",
    features: {
      publicRepositories: "Unlimited",
      privateRepositories: 10,
      support: "24/7 email and chat",
      ciTool: "Yes",
      browserTool: "Yes",
      autoFix: "Yes",
    }
  },
  { 
    title: "Unlimited",
    isPrimary: false,
    duration: 'per month',
    price: "$99",
    buttonLabel: "Add to GitHub",
    freeTrial: true,
    marketplaceUrl: "https://github.com/marketplace/django-doctor/plan/MDIyOk1hcmtldHBsYWNlTGlzdGluZ1BsYW41Nzc2#pricing-and-setup",
    features: {
      publicRepositories: "Unlimited",
      privateRepositories: "Unlimited",
      support: "24/7 email and chat",
      ciTool: "Yes",
      browserTool: "Yes",
      autoFix: "Yes",
    }
  },
]

function PricingBox(props) {
  const JoinButton = props.pricing.isPrimary ? ButtonPrimary : Button 

  return (
    <Box
      marginRight="15px"
      marginLeft="15px"
      paddingLeft="20px"
      paddingRight="20px"
      className="text-center pricing-box bg-white price-active col-md-4 mb-md-0 mb-4 pb-6"
    >
      {props.pricing.isRibbon && <div className="ribbon-box"><Text>Popular</Text></div> }
      <Heading as="h4" fontSize="1" className="text-uppercase">{props.pricing.title}</Heading>
      <Heading as="h1">{ props.pricing.price }</Heading>
      <Text className="text-uppercase">{ props.pricing.duration }</Text>
      <Box className="mt-6 mb-6">
        <p>Protects every PR: <b>{props.pricing.features.ciTool}</b></p>
        <p>Suggests the fix: <b>{props.pricing.features.autoFix}</b></p>
        <p>Codebase audit: <b>{props.pricing.features.browserTool}</b></p>
        <p>Public repositories: <b>{props.pricing.features.publicRepositories}</b></p>
        <p>Private repositories: <b>{props.pricing.features.privateRepositories}</b></p>
        <p>Support: <b>{props.pricing.features.support}</b></p>
      </Box>
      {!props.pricing.freeTrial && <JoinButton as="a" href={props.pricing.marketplaceUrl}>{props.pricing.buttonLabel}</JoinButton> }
      {props.pricing.freeTrial && (
        <div>
          <JoinButton as="a" href={props.pricing.marketplaceUrl}>{props.pricing.buttonLabel}</JoinButton>
        </div>
      )}
    </Box>
  );
}


export default function Component(props) {
  const productDetails = useProduct()
  return (
    <Box className="container-lg pb-4" padding="0">
      <Heading
        as="h2"
        marginBottom="40px"
        style={{textTransform: 'uppercase'}}
        textAlign="center"
        className="text-white pt-12"
      >{props.title}</Heading>
      {productDetails.id !== 'djangodoctor' && <Text as="p" className="text-white f3 text-center">One subscription unlocks all of our code review capabilities: Python, Django and HTML.</Text>}
      { props.showDescription && <Text className="text-white ml-3 f3 text-center" as="p">GitHub integration. {productDetails.name} protects your build and suggests fixes in your PRs. <Link to="/" className="text-white">Read more</Link>.</Text>}
      <Box marginTop="50px" className="d-md-flex">
        <PricingBox pricing={pricings[0]} />
        <PricingBox pricing={pricings[1]} />
        <PricingBox pricing={pricings[2]} />
      </Box>
      {productDetails.id !== 'djangodoctor' && <Text as="p" className="text-white f3 text-center mt-6 mb-0 pb-0">Or read about our <Link to="/features/python" className="text-white text-underline">Python</Link>, <Link to="/features/django" className="text-white text-underline">Django</Link> and <Link to="/features/django" className="text-white text-underline">HTML</Link> code review capabilities.</Text>}
    </Box>
  )
}


Component.defaultProps = {
  title: "Our Price"
}